import { render, staticRenderFns } from "./AddQuantity.vue?vue&type=template&id=2fab4070&scoped=true&"
import script from "./AddQuantity.vue?vue&type=script&lang=js&"
export * from "./AddQuantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fab4070",
  null
  
)

export default component.exports